import { render, staticRenderFns } from "./ProductVariant.vue?vue&type=template&id=68558970&scoped=true"
import script from "./ProductVariant.vue?vue&type=script&lang=ts"
export * from "./ProductVariant.vue?vue&type=script&lang=ts"
import style0 from "./ProductVariant.vue?vue&type=style&index=0&id=68558970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68558970",
  null
  
)

export default component.exports